import estyled from '@signal/theme/emotion'
import Typography from '@material-ui/core/Typography'
import { getColorPrimarySelector } from '@signal/theme/selectors'

const linkColorSelector = getColorPrimarySelector()
const activeLinkColorSelector = getColorPrimarySelector('dark')

export const TypographyBase = estyled(Typography)`
  > a {
    color: ${linkColorSelector};
    &:active,
    &:hover,
    &:focus {
      color: ${activeLinkColorSelector};
      text-decoration: underline;
    }
  }
`
